<template>
  <div>
    <div class="accordion-item">
      <div
        @click="toggle()"
        @keydown.enter.prevent="toggle()"
        @keydown.space.prevent="toggle()"
        class="accordion-title"
        :aria-expanded="open"
        role="button"
        tabindex="0"
      >
        {{ title }}
        <span class="accordion-icon" :class="{ 'open': open }">&#9662;</span>
      </div>
      <div v-if="open" class="accordion-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['toggled'],
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      open: false,
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
      this.$emit('toggled', this.open);
    }
  }
};
</script>

<style scoped>
.accordion-item {
  border: 1px solid rgba(207, 199, 189, 0.82);
  border-radius: 1.25rem;
  background: rgba(255, 255, 255, 0.72);
  overflow: hidden;
}

.accordion-title {
  cursor: pointer;
  padding: 0.95rem 1rem;
  background: transparent;
  color: var(--uk-navy-900);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8125rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.accordion-icon {
  transition: 0.2s;
  display: inline-block;
  transform: rotate(180deg);
  color: var(--uk-stone-500);
}

.accordion-icon.open {
  transform: rotate(0);
}

.accordion-content {
  padding: 0 1rem 1rem;
  overflow: hidden;
}
</style>
